/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import { accessAPI, Boton, Titulo, Formulario, Sidebar, TablaFiltrable } from "../../../../shared";

import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";

export default function ProductoCaracteristicasCriticas({
  productoCaracteristicasCriticas,
  certificadoTipoId
}) {
  const [caracteristicas, setCaracteristicas] = useState(
    productoCaracteristicasCriticas
  );
  const [sidebarNuevoVisible, setSidebarNuevoVisible] = useState(false);
  const [sidebarEditarVisible, setSidebarEditarVisible] = useState(false);
  const [caracteristicaEditando, setCaracteristicaEditando] = useState(null);
  const [loaderEnvio, setLoaderEnvio] = useState(false);
  const toast = useRef(null);
  const menuRef = useRef(null);
  const filaSeleccionada = useRef(null);

  function agregarCaracteristica(datosFormulario) {
    setLoaderEnvio(true);
    accessAPI(
      "POST",
      `admin/producto/certificadotipo/${certificadoTipoId}/caracteristicacritica`,
      datosFormulario,
      (respuesta) => {
        setCaracteristicas((prev) => [...prev, respuesta]);
        setSidebarNuevoVisible(false);
        setLoaderEnvio(false);
        toast.current?.show({
          severity: "success",
          summary: "Agregado",
          detail: "Característica crítica agregada exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg || "Error al agregar la característica crítica",
          sticky: true
        });
        setLoaderEnvio(false);
      }
    );
  }

  function editarCaracteristica(datosFormulario) {
    setLoaderEnvio(true);
    accessAPI(
      "PUT",
      `admin/producto/config/productocaracteristicacritica/${caracteristicaEditando.id}`,
      datosFormulario,
      (respuesta) => {
        setCaracteristicas((prev) =>
          prev.map((c) =>
            c.id === caracteristicaEditando.id ? { ...c, ...respuesta } : c
          )
        );
        setSidebarEditarVisible(false);
        setLoaderEnvio(false);
        setCaracteristicaEditando(null);
        toast.current?.show({
          severity: "success",
          summary: "Actualizado",
          detail: "Característica crítica actualizada exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg ||
            "Error al actualizar la característica crítica",
          sticky: true
        });
        setLoaderEnvio(false);
      }
    );
  }

  function eliminarCaracteristica(caracteristica) {
    accessAPI(
      "DELETE",
      `admin/producto/caracterisitcacritica/${caracteristica.id}`,
      null,
      () => {
        setCaracteristicas((prev) =>
          prev.filter((c) => c.id !== caracteristica.id)
        );
        toast.current?.show({
          severity: "success",
          summary: "Eliminado",
          detail: "Característica crítica eliminada exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg || "Error al eliminar la característica crítica",
          sticky: true
        });
      }
    );
  }

  function onRowReorder(e) {
    setCaracteristicas(e.value);
    const ids = e.value.map((c) => c.id);
    accessAPI(
      "PUT",
      "admin/producto/productocaracteristicacritica/reordenar",
      { ids },
      () => {},
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al reordenar",
          sticky: true
        });
      }
    );
  }

  function abrirEditar(caracteristica) {
    setCaracteristicaEditando(caracteristica);
    setSidebarEditarVisible(true);
  }

  const menuItems = [
    {
      label: "Editar",
      icon: "pi pi-pencil",
      command: () => abrirEditar(filaSeleccionada.current)
    },
    {
      label: "Eliminar",
      icon: "pi pi-trash",
      className: "text-red-500",
      command: () => {
        confirmDialog({
          message: "¿Eliminar esta característica crítica?",
          icon: "pi pi-exclamation-circle",
          accept: () => eliminarCaracteristica(filaSeleccionada.current)
        });
      }
    }
  ];

  const agregarFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "etiqueta",
            tipoitemformularioid: 1,
            etiqueta: "Etiqueta",
            requerido: true
          },
          {
            nombre: "notas",
            tipoitemformularioid: 1,
            etiqueta: "Notas en formulario"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Agregar característica",
        callback: agregarCaracteristica,
        validar: true
      }
    ]
  };

  const editarFormConfig = caracteristicaEditando
    ? {
        secciones: [
          {
            campos: [
              {
                nombre: "etiqueta",
                tipoitemformularioid: 1,
                etiqueta: "Etiqueta",
                requerido: true,
                respuesta: caracteristicaEditando.etiqueta
              },
              {
                nombre: "notas",
                tipoitemformularioid: 1,
                etiqueta: "Notas en formulario",
                respuesta: caracteristicaEditando.notas
              }
            ]
          }
        ],
        botones: [
          {
            etiqueta: "Guardar cambios",
            callback: editarCaracteristica,
            validar: true
          }
        ]
      }
    : null;

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Menu model={menuItems} popup ref={menuRef} />
      <Card>
        <Titulo
          botones={
            <Boton icono negro callback={() => setSidebarNuevoVisible(true)}>
              <i className="pi pi-plus" />
            </Boton>
          }
        >
          Características críticas
        </Titulo>
        <TablaFiltrable conFiltros={false}
          value={caracteristicas}
          nombreArchivo="caracteristicas_criticas"
          reorderableRows
          onRowReorder={onRowReorder}
          emptyMessage="No hay características críticas definidas"
        >
          <Column rowReorder style={{ width: "3rem" }} />
          <Column field="etiqueta" header="Etiqueta" />
          <Column
            body={(rowData) => (
              <Boton
                icono
                negro
                chico
                callback={(e) => {
                  filaSeleccionada.current = rowData;
                  menuRef.current.toggle(e);
                }}
              >
                <i className="pi pi-ellipsis-v" />
              </Boton>
            )}
            style={{ width: "3rem", textAlign: "center" }}
          />
        </TablaFiltrable>
      </Card>

      <Sidebar
        visible={sidebarNuevoVisible}
        position="right"
        onHide={() => setSidebarNuevoVisible(false)}
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nueva característica crítica</Titulo>
        <Formulario
          config={agregarFormConfig}
          loader={loaderEnvio}
          key={caracteristicas.length}
        />
      </Sidebar>

      <Sidebar
        visible={sidebarEditarVisible}
        position="right"
        onHide={() => {
          setSidebarEditarVisible(false);
          setCaracteristicaEditando(null);
        }}
        className="w-full lg:w-30rem md:w-30rem"
      >
        {editarFormConfig && (
          <>
            <Titulo>Editar característica crítica</Titulo>
            <Formulario
              config={editarFormConfig}
              loader={loaderEnvio}
              key={caracteristicaEditando?.id}
            />
          </>
        )}
      </Sidebar>
    </>
  );
}
